export const store = () => {
    return window.axios.post('/api/widget');
}
export const update = (widget) => {
    return window.axios.put('/api/widget', widget);
}
export const show = () => {
    return window.axios.get('/api/widget');
}
